import React, { useState } from 'react'

import { NumberFieldData } from '../../../mockData/inventory'
import useStyles from './styles/InventoryRoomTypeRowMobile.styles'

interface InventoryProviderRowProps {
  name: string
  availability: NumberFieldData[]
  //   weekendIndexes: number[]
  //   numberOfRatePlans: number
  //   showRatePlans: boolean
  //   setshowRatePlans: React.Dispatch<React.SetStateAction<boolean>>
}

const InventoryProviderRow: React.FC<InventoryProviderRowProps> = ({
  name,
  availability
  //   weekendIndexes,
  //   numberOfRatePlans,
  //   showRatePlans,
  //   setshowRatePlans
}) => {
  const classes = useStyles()
  const [hoveredItem, sethoveredItem] = useState<number | null>(null)

  return (
    <div className={classes.roomTypeRow}>
      {/* <div className={classes.rowNameContainer}>
        <Typography variant="h4" className={classes.rowName}>
          {getTranslate(name)}
        </Typography>

        <ArrowRightIcon className={[classes.channelArrowRight].join(' ')} />
      </div> */}
      {/* <div className={classes.dayContainer}>
          <Typography variant="h5">{getTranslate('AVAIL')}</Typography>
        </div> */}
      <div className={classes.avalabilitiesContainer}>
        <div className={[classes.dayContainer].join(' ')} />
        {availability?.map((availItem, index) => (
          <div
            key={`${name}-${availItem.date}`}
            className={[
              classes.dayContainer,
              hoveredItem === index ? classes.selectedDayContainer : ''
            ].join(' ')}>
            <input
              defaultValue={availItem.value}
              onClick={(e) => {
                sethoveredItem(index)
                e.currentTarget.select()
              }}
              onBlur={() => {
                sethoveredItem(null)
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default InventoryProviderRow
